import Abstract from "../../../abstract-view/abstract.js";

export default class Form extends Abstract {
  constructor(element) {
    super();

    this._element = element;

    this._slidersFieldsets = null;
    this._checkboxesFieldsets = null;

    this._changeHandler = this._changeHandler.bind(this);
    this._submitHandler = this._submitHandler.bind(this);
  }

  getSlidersFieldsets() {
    if (!this._slidersFieldsets) {
      this._slidersFieldsets = this._element.querySelectorAll(`.filter-fieldset_numbers`);
    }

    return this._slidersFieldsets;
  }

  getCheckboxesFieldsets() {
    if (!this._checkboxesFieldsets) {
      this._checkboxesFieldsets = this._element.querySelectorAll(`.filter-fieldset_checkbox`);
    }

    return this._checkboxesFieldsets;
  }

  getInputsElements() {
    return this._element.querySelectorAll(`input`);
  }

  setChangeHandler(callback) {
    this._callback.change = callback;
    this._element.addEventListener(`change`, this._changeHandler);
  }

  setSubmitHandler(callback) {
    this._callback.submit = callback;
    this._element.addEventListener(`submit`, this._submitHandler);
  }

  _changeHandler() {
    this._callback.change();
  }

  _submitHandler(evt) {
    this._callback.submit(evt);
  }
}
